import React, { FC, memo, useCallback } from 'react'

import { useMutation } from '@apollo/client'

import { CANCEL_APPLYING_GIFT_CARD } from 'Const'
import { refreshingOrderTotalInSafari } from 'Utils'

interface Props {
  cardLast4: string
  id: string
}

const GCButton: FC<Props> = ({ cardLast4, id }) => {
  const [removeGiftCard] = useMutation(CANCEL_APPLYING_GIFT_CARD, {
    update() {
      refreshingOrderTotalInSafari()
    },
  })
  const handleRemove = useCallback(() => removeGiftCard({ variables: { id } }), [id, removeGiftCard])

  return (
    <button aria-label="Remove gift card" className="btn" type="button" onClick={handleRemove}>
      <span>**** **** **** {cardLast4}</span>
      <svg className="sociavore-icon" viewBox="0 0 24 24">
        <line x1="18" x2="6" y1="6" y2="18"></line>
        <line x1="6" x2="18" y1="6" y2="18"></line>
      </svg>
    </button>
  )
}

export default memo(GCButton)
